export const GET_COMMISSIONS_SUMMARY = 'GET_COMMISSIONS_SUMMARY';
export const GET_COMMISSIONS_SUMMARY_SUCCESS = 'GET_COMMISSIONS_SUMMARY_SUCCESS';
export const GET_COMMISSIONS_SUMMARY_ERROR = 'GET_COMMISSIONS_SUMMARY_ERROR';

export const GET_COMMISSION_SUMMARY_EXCEL = 'GET_COMMISSION_SUMMARY_EXCEL';
export const GET_COMMISSION_SUMMARY_EXCEL_SUCCESS = 'GET_COMMISSION_SUMMARY_EXCEL_SUCCESS';
export const GET_COMMISSION_SUMMARY_EXCEL_ERROR = 'GET_COMMISSION_SUMMARY_EXCEL_ERROR';